import {
  StyleSheet,
  Modal as ReactNativeModal,
  View,
  ViewStyle,
  TouchableOpacity,
} from 'react-native';
import React, {PropsWithChildren} from 'react';
import {spacing, corner_radius} from 'theme/Units';
import colors from 'theme/Colors';
import {Icon} from 'ui-kits';

type ModalPropsTypes = Readonly<
  PropsWithChildren<{
    open: boolean;
    onClose: () => void;
    animationType?: 'slide' | 'none' | 'fade';
    style?: ViewStyle;
  }>
>;

export function Modal(props: ModalPropsTypes) {
  const {
    open,
    onClose,
    children,
    animationType = 'none',
    style: overrideStyles,
  } = props;

  return (
    <ReactNativeModal
      animationType={animationType}
      transparent={true}
      visible={open}
      onRequestClose={onClose}>
      <View style={baseStyles.modalContainer}>
        <View style={[baseStyles.modalContent, overrideStyles]}>
          <TouchableOpacity onPress={onClose} style={baseStyles.closeButton}>
            <Icon type="cross" size={14} />
          </TouchableOpacity>
          {children}
        </View>
      </View>
    </ReactNativeModal>
  );
}
type styleProps = {
  modalContainer: ViewStyle;
  modalContent: ViewStyle;
  closeButton: ViewStyle;
};
const baseStyles: styleProps = StyleSheet.create({
  modalContainer: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: spacing['8'],
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: colors.palette.white,
    minHeight: 64,
    alignItems: 'center',
    padding: spacing['8'],
    borderRadius: corner_radius['rounded-lg'],
    overflowY: 'auto',
    boxSizing: 'border-box',
  },
  closeButton: {
    position: 'absolute',
    top: 30,
    right: 30,
    zIndex: 100,
    outlineColor: 'transparent',
  },
});
